module.exports = __webpack_public_path__ + "static/media/cross.94c556d3.png";